/* import __COLOCATED_TEMPLATE__ from './market-input-number.hbs.js'; */
var _class, _descriptor, _descriptor2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { isBlank, isNone, isPresent } from '@ember/utils';
// eslint-disable-next-line import/named
import { NumberFormatter } from 'field-kit';
function isNumber(value) {
  return typeof value === 'number' && !Number.isNaN(value);
}
let MarketInputNumber = (_class = class MarketInputNumber extends Component {
  constructor(...args) {
    super(...args);
    // Internal representation of what has been typed into the market-input-text
    _initializerDefineProperty(this, "inputValue", _descriptor, this);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    _initializerDefineProperty(this, "formatter", _descriptor2, this);
  }
  // The value displayed in the template's market-input-text
  get displayValue() {
    if (isNone(this.args.value)) {
      return '';
    }
    const parsedInputValue = this.numberFormatter.parse(this.inputValue);

    // prefer formatted @value as the source of truth if it's different from the internal input value
    if (this.args.value !== parsedInputValue) {
      return this.numberFormatter.format(this.args.value);
    }

    // prefer the internal input value if it has the same numeric value as @value
    // (e.g. 101 can be represented as both '101' or '101.0')
    return this.inputValue;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  get numberFormatter() {
    const numberFormatter = this.formatter.buildNumberFormatter();
    if (isNumber(this.args.max)) {
      numberFormatter.setMaximum(this.args.max);
    }
    if (isNumber(this.args.precision)) {
      numberFormatter.setMaximumFractionDigits(this.args.precision).setRoundingMode(NumberFormatter.Rounding.FLOOR);
    }
    if (isNumber(this.args.min)) {
      numberFormatter.setMinimum(this.args.min);
    }
    return numberFormatter;
  }
  handleMarketInputValueChange(event) {
    // prevent market-input-text from changing prior to input validation
    event.preventDefault();
    const newInputValue = event?.detail?.value;
    const parsedValue = this.numberFormatter.parse(newInputValue);
    // newValue can be different from parsedValue when @precision is present (e.g. when @precision = 2 => 4.567 vs 4.56)
    const newValue = this.numberFormatter.parse(this.numberFormatter.format(parsedValue));
    const currentValue = this.numberFormatter.parse(this.displayValue);

    // prevent unparsable values from being entered (except blank strings)
    if (isPresent(currentValue) && !isBlank(newInputValue) && isNone(parsedValue)) {
      return;
    }

    // update the market-input-text value
    this.inputValue = newInputValue;

    // propagate value changes to the parent
    if (newValue !== this.args.value) {
      this.args.onChange(newValue);
    }
  }
  handleBlur() {
    this.inputValue = this.numberFormatter.format(this.inputValue);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "inputValue", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "formatter", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "handleMarketInputValueChange", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleMarketInputValueChange"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleBlur", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleBlur"), _class.prototype), _class);
export { MarketInputNumber as default };